import { updateBeamUrl } from '@utils/updateBeamUrl/updateBeamUrl';

export interface IQa {
  id: string;
  label: string;
  uri: string;
  ownerStudioId?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface IQaApiModel {
  id: string;
  label: string;
  uri: string;
  ownerStudioId?: string;
  createdAt: string;
  updatedAt: string;
}

export default class Qa implements IQa {
  public readonly id: string;

  public readonly label: string;

  public readonly uri: string;

  public readonly ownerStudioId?: string;

  public readonly createdAt: Date;

  public readonly updatedAt: Date;

  constructor(
    id: string,
    label: string,
    createdAt: Date,
    updatedAt: Date,
    uri: string,
    ownerStudioId?: string,
  ) {
    this.id = id;
    this.label = label;
    this.uri = uri;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.ownerStudioId = ownerStudioId;
  }

  static fromApiModel(apiModel: IQaApiModel) {
    const { id, label, ownerStudioId } = apiModel;
    const uri = updateBeamUrl(apiModel.uri);
    const createdAt = new Date(Date.parse(apiModel.createdAt));
    const updatedAt = new Date(Date.parse(apiModel.updatedAt));

    return new Qa(id, label, createdAt, updatedAt, uri, ownerStudioId);
  }

  static arrayFromApiModel(arrayApiModel: IQaApiModel[]) {
    const array = arrayApiModel.map(apiModel => Qa.fromApiModel(apiModel));

    return array;
  }
}
